export default "__VITE_ASSET__3f1_SC2a__"